import TablaConciliacion from "../../../TablaConciliacion";

function TablaTunelDelOriente() {
  return <TablaConciliacion nombreUseCase="TUNELDELORIENTE" titulo="TUNEL DEL ORIENTE" />;
}

export default TablaTunelDelOriente;
